export const supplier = {
  create_supplier: "Create a supplier",
  create_article: "Create an item",
  form: {
    name: "Name",
    name_required: "The name is required",
    email: "Email",
    telephone: "Phone",
    address: "Address",
    role: "Role",
    kbis: "KBIS",
    fiscal_doc: "Fiscal Document",
    urssaf_doc: "URSSAF Document",
    creating: "Creating...",
    submit: "Create",
    name_placeholder: "Supplier name",
    email_placeholder: "Email",
    telephone_placeholder: "Phone number",
    address_placeholder: "Address",
    role_placeholder: "Role ID",
    title: "Edit Supplier",
    label_urssaf: "URSSAF document",
    label_kbis: "KBIS document",
    label_fiscal: "Fiscal document",
  },
  create_success: "Supplier created successfully.",
  create_error: "Error while creating supplier.",

  table: {
    status: "Status",
    isVerified: "Verified",
    createdAt: "Created At",
  },
  actions: {
    edit: "Edit",
    disable: "Disable",
    enable: "Enable",
    consulter: "consult",
  },
  header_title: "Supplier List",
  delete_dialog: {
    title: "Confirm Desactivation",
    description: "Are you sure you want to disable this supplier?",
    cancel: "Cancel",
    submit: "Disable",
  },
  delete_success: "Supplier successfully disabled",
  delete_error: "Error disabling supplier",
  update: "Validate",
  article: "Items",
};
